import React from 'react';
import { Container, Text } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import CreateTextWinAmountAndCurrencySymbol from '../../createTextWinAmountAndCurrencySymbol';
import { boostedJackpotStore } from '../../../../../store/boostedJackpotStore';
import { userInfoStore } from '../../../../../store/userInfoStore';
import { applicationStore } from '../../../../../store/applicationStore';

const BoostedJackpotInitialPopupWinners = observer(({ x, y }) => {
  const { winningCount, prizePoolAmount } = boostedJackpotStore;
  const {
    canvasTranslationKeys: { WINNING_COUNT },
  } = applicationStore;
  return (
    <Container x={x} y={y} name='BoostedJackpotInitialPopupWinners'>
      <CreateTextWinAmountAndCurrencySymbol
        x={0}
        y={0}
        color='#F5F7FC'
        amount={prizePoolAmount}
        margin={65}
        fontSize={54}
      />
      <Container x={60}>
        <Text
          y={60}
          anchor={0.5}
          text={WINNING_COUNT}
          style={{
            _fontSize: 20,
            _fontWeight: 700,
            _fontFamily: 'poppinsMedium',
            _fill: '#F5F7FC',
            align: 'center',
            _wordWrap: true,
            _wordWrapWidth: 206,
          }}
          resolution={2}
        />
        <Text
          y={100}
          anchor={0.5}
          text={`${winningCount}+`}
          style={{
            _fontSize: 36,
            _fontWeight: 700,
            _fontFamily: 'poppinsMedium',
            _fill: '#FFC33E',
            align: 'center',
          }}
          resolution={2}
        />
      </Container>
    </Container>
  );
});

export default BoostedJackpotInitialPopupWinners;
